import React, { useState, useEffect } from 'react'
import { ToolbarSection } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarSection'
import { ToolbarItem } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarItem'
import { defaultProps } from './index'
import { adminApiAxiosInstance } from '../../services/api'

export const CircleBoxSettings = (props) => {

  const [urlOpts, setUrlOpts] = useState()

  const animationVariantOpts = [
    { label: 'Verticale', value: 'vertical' },
    { label: 'Orizzontale', value: 'horizontal' },
  ]

  useEffect(async () => {
    adminApiAxiosInstance.get('linkable_objects/').then(res => {
      setUrlOpts(
        res.data.reduce(
          (r, x) =>
            r.concat(
              x.linkable_objects.map(y => ({
                label: y.alias,
                value: x.content_type.id + '|' + y.id,
              }))
            ),
          []
        )
      )
    })
  }, [])

  return (
    <>
      <ToolbarSection title="Settings" initOpen>
        <ToolbarItem
          propKey="block"
          propSubKey="animationVariant"
          type="select"
          options={animationVariantOpts}
          label="Animazione"
          defaultValue={defaultProps['animationVariant']}
        />
        <ToolbarItem
          propKey="block"
          propSubKey="ctaLabel"
          type="text"
          label="Cta label"
          defaultValue={defaultProps['ctaLabel']}
        />
        <ToolbarItem
          propKey="block"
          propSubKey="link"
          type="text"
          label="URL"
          defaultValue={defaultProps['link']}
        />
        {urlOpts && (
          <ToolbarItem
            propKey="block"
            propSubKey="pageLink"
            type="select"
            label="Page Link"
            options={urlOpts}
            nullable
            defaultValue={defaultProps['pageLink']}
          />
        )}
        <ToolbarItem
          propKey="block"
          propSubKey="openNewTab"
          type="switch"
          label="Open in new tab"
          defaultValue={defaultProps['openNewTab']}
        />
      </ToolbarSection>
    </>
  );
};
